import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface InformationStateBadgeProps {
    state: 'complete' | 'incomplete';
    text?: string;
}

const InformationStateBadge = ({ state }: InformationStateBadgeProps) => {
    const { t } = useTranslation('carcinogenicReport');

    let stateText = '';
    let bgColor = '';
    let textColor = '';

    switch (state) {
        case 'complete':
            stateText = t('informationStateBadge.complete');
            bgColor = '#F3FAF3';
            textColor = '#358438';
            break;
        case 'incomplete':
            stateText = t('informationStateBadge.incomplete');
            bgColor = '#FEF3F2';
            textColor = '#9D2017';
            break;
        default:
            stateText = '#';
            bgColor = '#888';
            textColor = '#000';
            break;
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: bgColor,
                padding: '4px 8px',
                borderRadius: '16px',
                fontWeight: 'bold',
                color: textColor
            }}
        >
            <span style={{ marginLeft: '4px' }}>{stateText}</span>
        </Box>
    );
};

export default InformationStateBadge;
